import { CountryCode, RegionMeta } from '../models/region.model';

export const RegionMetaData: Record<CountryCode, RegionMeta> = {
  MX: {
    colorCode: '#44A04733',
  },
  US: {
    colorCode: '#3e8aee33',
  },
  JP: {
    colorCode: '#FF330033',
  },
  CA: {
    colorCode: '#f5f54266',
  },
  AU: {
    colorCode: '#FFA40066',
  },
};
